// Route → metadata map used by PageLayout to apply title + OG + Twitter
// tags on every navigation. Dynamic routes (leadership bios, news articles)
// set their own meta via usePageMeta inside the page component.

const DEFAULT_OG_IMAGE = 'https://mobilecorex.ng/og-image.png';

export const PAGE_META = {
  '/': {
    title: 'MobileCoreX — MVNE Mobile Virtual Network Enabler Telecom as a Service Solution',
    description: 'Like a franchise for mobile networks — MobileCoreX provides the infrastructure. You show up and launch your brand',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Launch
  '/launch-an-mvno': {
    title: 'Launch an MVNO in Nigeria',
    description: 'A managed 12–16 week programme from MVNO concept to commercial operations on NCC-licensed infrastructure.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/launch-an-mvno/aspiring-mvno': {
    title: 'Aspiring MVNO — Licence + Launch',
    description: 'No NCC licence yet? MCX guides you through tier selection, application, and platform integration in 12–16 weeks.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/launch-an-mvno/existing-licensee': {
    title: 'Existing Licensee — Fast-Track Launch',
    description: 'You hold an NCC MVNO licence but lack the operational infrastructure to launch. MCX closes the gap in 8–12 weeks.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/launch-an-mvno/mobile-brand': {
    title: 'Mobile Brand — Brand-Led Launch',
    description: 'An established brand launching mobile services under an existing organisational structure. 12–20 weeks.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Platform
  '/platform': {
    title: 'The MCX Platform',
    description: 'The MobileCoreX platform: four integrated modules covering every layer of MVNO operations — core network, BSS, subscriber onboarding, and the B2B2X marketplace.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/platform/mcx-core': {
    title: 'MCX Core — Network Infrastructure',
    description: 'HLR/HSS, SMSC, intelligent routing, and multi-host MNO connectivity. The foundational network layer for every MCX MVNO.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/platform/mcx-bss': {
    title: 'MCX BSS — Business Support System',
    description: 'Cloud-native real-time charging, billing, customer management, and product catalogue. Built on Tecnotree D-Stack.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/platform/mcx-activate': {
    title: 'MCX Activate — SIM, eSIM & KYC',
    description: 'Subscriber onboarding: SIM, eSIM, NIN-based KYC, and lifecycle management. Powered by VerifyMe Nigeria and Monty Mobile.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/platform/mcx-marketplace': {
    title: 'MCX Marketplace — B2B2X Digital Services',
    description: 'B2B2X marketplace for digital services beyond connectivity. Education, gaming, sports, health, and lifestyle bundles under your brand.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Solutions
  '/solutions/banks-and-fintechs': {
    title: 'Mobile Services for Banks & Fintechs',
    description: 'Mobile services that deepen customer relationships and open new revenue lines for licensed Nigerian financial institutions.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/solutions/consumer-brands': {
    title: 'Mobile Services for Consumer Brands',
    description: 'Mobile services for retail and loyalty-programme operators with large existing customer bases.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/solutions/enterprise-and-corporate-affinity': {
    title: 'Mobile Services for Enterprise & Corporate Affinity',
    description: 'Employee SIMs, policy control, and unified billing for Nigerian enterprise groups and conglomerates.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/solutions/diaspora-and-affinity': {
    title: 'Mobile Services for Diaspora & Affinity Audiences',
    description: 'Mobile services tailored for diaspora, faith, student, and community-affinity audiences.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/solutions/iot-and-m2m': {
    title: 'IoT & M2M Connectivity',
    description: 'Per-device subscriber management and eSIM at scale for logistics, energy, agritech, and industrial deployments.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/solutions/foreign-mvno-landing': {
    title: 'Foreign MVNO Landing — Nigeria Market Entry',
    description: 'Structured Nigeria market entry for foreign mobile operators evaluating the Nigerian MVNO market.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Regulatory
  '/regulatory': {
    title: 'Regulatory — Nigerian MVNO Framework',
    description: 'The four pillars of the Nigerian regulatory framework for MVNOs and how MCX addresses each at the platform layer.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/regulatory/ncc-mvno-framework': {
    title: 'NCC MVNO Framework — Five-Tier Licensing',
    description: 'The five-tier NCC licensing structure, from Tier 1 SVO through to Tier 5 UVO. Compliance positioning and licence implications.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/regulatory/ndpa-and-data-protection': {
    title: 'NDPA 2023 — Data Protection for MVNOs',
    description: 'Nigeria Data Protection Act 2023 controller and processor obligations as they apply to MVNO operations.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/regulatory/sim-registration-and-kyc': {
    title: 'SIM Registration & KYC — NIN Compliance',
    description: 'NIN-based subscriber registration and the ongoing SIM compliance requirements for Nigerian mobile operators.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/regulatory/lawful-intercept': {
    title: 'Lawful Intercept — Regulatory Obligations',
    description: 'Regulatory intercept obligations and platform-layer handling. MCX delivers LI infrastructure via Latro.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // About hub & spokes
  '/about': {
    title: 'About MobileCoreX',
    description: 'The institutional MVNE platform for Nigerian telecoms. Who we are, what we do, and how we do it.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/who-we-are': {
    title: 'Who We Are',
    description: 'The institutional MVNE platform for Nigerian telecoms. An overview of MobileCoreX as an organisation.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/what-we-do': {
    title: 'What We Do',
    description: 'The platform layer between Nigerian MNOs and institutional MVNOs. Our role in the MVNO value chain.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/how-we-do-it': {
    title: 'How We Do It',
    description: 'The MCX operating model, regulatory positioning, and the institutional posture behind every MVNO deployment.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/company-facts': {
    title: 'Company Facts',
    description: 'RC, registered address, regulatory positioning, capital structure, and other institutional facts about MobileCoreX Limited.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/leadership': {
    title: 'Leadership',
    description: 'The Board of Directors and Executive Officers building the MobileCoreX platform.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/leadership/board-of-directors': {
    title: 'Board of Directors',
    description: 'The Board of Directors of MobileCoreX Limited.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/about/leadership/executive-officers': {
    title: 'Executive Officers',
    description: 'The Executive Officers of MobileCoreX Limited.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Supporting
  '/partners': {
    title: 'MCX Technical Partners',
    description: 'Tecnotree, WTL Belgium, Monty Mobile, VerifyMe Nigeria, Latro, and Huawei — the named MCX technical stack.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/trust': {
    title: 'Trust — SLA, Security & Compliance',
    description: 'SLA targets, security posture, certifications, audit reports, and the MCX incident response framework.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/contact': {
    title: 'Contact MobileCoreX',
    description: 'Five contact pathways for MVNOs, partners, press, investors, and general enquiries — each with a stated response commitment.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/book-a-call': {
    title: 'Book a 30-Minute Scoping Call',
    description: 'A structured 30-minute call to establish fit between your objectives and what MCX delivers. No commitment.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/news-and-insights': {
    title: 'News and Insights',
    description: 'Press releases, case studies, market insights, and company news from MobileCoreX.',
    ogImage: DEFAULT_OG_IMAGE,
  },

  // Legal
  '/legal': {
    title: 'Legal',
    description: 'Privacy policy, terms of service, cookie policy, and accessibility statement for MobileCoreX Limited.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/legal/privacy-policy': {
    title: 'Privacy Policy',
    description: 'How MobileCoreX collects, uses, and protects personal data, in compliance with the Nigeria Data Protection Act 2023.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/legal/terms-of-service': {
    title: 'Terms of Service',
    description: 'The legal terms governing use of the MobileCoreX website and services.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/legal/cookie-policy': {
    title: 'Cookie Policy',
    description: 'How MobileCoreX uses cookies and similar technologies on this website.',
    ogImage: DEFAULT_OG_IMAGE,
  },
  '/legal/accessibility': {
    title: 'Accessibility Statement',
    description: 'MobileCoreX is committed to WCAG 2.2 AA accessibility across mobilecorex.ng.',
    ogImage: DEFAULT_OG_IMAGE,
  },
};

export const NOT_FOUND_META = {
  title: 'Page Not Found',
  description: 'The page you were looking for is not available.',
  ogImage: DEFAULT_OG_IMAGE,
};

export function getPageMeta(pathname) {
  // Normalise trailing slash (the preview proxy may append one on hard reloads,
  // e.g. /partners → /partners/) so the lookup is stable.
  const path = pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (PAGE_META[path]) return PAGE_META[path];

  // Sensible fallbacks for dynamic routes — individual pages may override.
  if (path.startsWith('/about/leadership/')) {
    return { title: 'Leadership Profile', description: 'Member of the MobileCoreX leadership.', ogImage: DEFAULT_OG_IMAGE };
  }
  if (path.startsWith('/news-and-insights/')) {
    return { title: 'News and Insights', description: 'Editorial content from MobileCoreX.', ogImage: DEFAULT_OG_IMAGE, ogType: 'article' };
  }
  if (path === '/book-a-call/confirmation') {
    return null; // Confirmation page sets its own noindex (v1.4 §6)
  }

  return null;
}
